import {useEffect, useState} from 'react';
import {HiOutlineChatAlt2} from 'react-icons/hi';
import PageContainer from "../../../components/page-container";
import Messenger from "./../messenger";
import SessionsList from "../sessions-list";
import {getDefaultAccessKeys} from "../../../services/app/app-access-key-service";
import {useAppContext} from "../../../helpers/hooks/common-hook";
import {useAppEnvironment} from "../../../helpers/hooks/app-environment-hook";
import EnvironmentPicker from "../../../components/environment-picker";

export default function LiveChatDashboard() {

    const { appInfo } = useAppContext();
    const [accessKey, setAccessKey] = useState();
    const [selectedSession, setSelectedSession] = useState();
    // Live sessions are recorded under `<appId>_live`; every request for the
    // list, the transcript and a takeover goes to the chosen environment's id.
    const { env, setEnv, envAppId } = useAppEnvironment(appInfo.appId);

    // The open conversation belongs to the environment it was picked in.
    useEffect(() => {
        setSelectedSession(undefined);
    }, [envAppId]);

    const fetchDefaultAccessKeys = async () => {
        if (appInfo.appId) {
            const response = await getDefaultAccessKeys(appInfo.appId);
            setAccessKey(response.accessKey)
        }
    }

    useEffect( () => {
        fetchDefaultAccessKeys();
    }, [appInfo]);

    const onSelectSession = (session) => {
        setSelectedSession(session);
    }

    const ready = selectedSession && accessKey;

    return (
        <PageContainer
            title="Conversations"
            subtitle="Allows human intervention in the bot's conversations."
        >
            <div className="mt-4 flex items-center gap-3">
                <EnvironmentPicker value={env} onChange={setEnv} />
                <span className="text-xs text-gray-500">
                    {env === 'live' ? 'Conversations with the published agent.' : 'Conversations from testing the draft agent.'}
                </span>
            </div>
            {/* One bordered panel split into a fixed rail and a fluid pane,
                matching the Trace console. The previous layout floated two cards
                on a grey field inside a 4-column grid, which left the transcript
                pinched and the panels unaligned. */}
            <div className="mt-4 grid h-[calc(100vh-16rem)] grid-cols-[17rem_minmax(0,1fr)] overflow-hidden rounded-lg border border-gray-200 bg-white">
                <SessionsList
                    appId={envAppId}
                    onSelectSession={onSelectSession}
                    selectedSessionId={selectedSession?.sessionId}
                />

                {ready ? (
                    <Messenger
                        key={`${envAppId}:${selectedSession.sessionId}`}
                        appId={envAppId}
                        session={selectedSession}
                        accessKey={accessKey}
                        chatBotSetting={{
                            header: 'BotCircuits',
                            welcomeMessage: 'Hello',
                            inputPlaceHolder: 'Ask any thing...'
                        }}
                    />
                ) : (
                    <div className="flex min-w-0 items-center justify-center bg-gray-50">
                        <div className="max-w-xs text-center">
                            <HiOutlineChatAlt2 size={26} className="mx-auto text-gray-300" />
                            <p className="mt-2 text-sm font-medium text-gray-900">
                                No conversation selected
                            </p>
                            <p className="mt-1 text-xs text-gray-500">
                                Pick a session on the left to read the transcript and take over from the bot.
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </PageContainer>
    )
}
